import { Container, Pagination, styled } from '@mui/material';
import {
  IApiCallStatus,
  ISaveRequestOutput,
  ValueLabel,
  variables,
} from '../common';
import {
  IMoreRequestData,
  isRequestStatusTypeForApproval,
  render,
  RequestStatusType,
} from '.';
import { useState } from 'react';

export function RequestStatus2d({
  properties,
  requests,
  getRequstsCallStatus,
  expandRequestValue,
  toggleExpandRequest,
  moreRequestData,
  requestStatusType,
  disableOperationsHelpDsk,
  now,
  selectedRequests,
  toggleRequestSelection,
  confirmCancelRequests,
}: {
  properties: ValueLabel<keyof ISaveRequestOutput>[];
  requests: ISaveRequestOutput[];
  getRequstsCallStatus: IApiCallStatus;
  expandRequestValue: (name: string) => boolean;
  toggleExpandRequest: (name: string) => void;
  moreRequestData: IMoreRequestData[];
  requestStatusType: RequestStatusType;
  disableOperationsHelpDsk: boolean;
  now?: Date;
  selectedRequests?: ISaveRequestOutput[];
  toggleRequestSelection?: (payload: ISaveRequestOutput) => void;
  confirmCancelRequests?: () => void;
}) {
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const s = PaginationStyles;
  switch (getRequstsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return (
        <>
          {requests.length > pageSize && (
            <Paginatio
              count={Math.ceil(requests.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}

          {render({ requestStatusType })(s)(properties)({
            disableOperationsHelpDsk,
            expandRequestValue,
            toggleExpandRequest,
            now,
            selectedRequests,
            toggleRequestSelection,
            confirmCancelRequests,
          })(moreRequestData)(
            requests.slice((page - 1) * pageSize, page * pageSize)
          )}

          {requests.length > pageSize && (
            <Paginatio
              count={Math.ceil(requests.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}
        </>
      );

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}

const Paginatio = styled(Pagination)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'right',
}));

const PaginationStyles = styled(Pagination)(({ theme }) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',

    '&>*+*': {
      marginTop: '1rem',
    },

    '@media (min-width: 60em)': {
      display: 'grid',
      gridTemplateColumns: ({
        requestStatusType,
      }: {
        requestStatusType: RequestStatusType;
      }) =>
        isRequestStatusTypeForApproval(requestStatusType)
          ? 'auto 160px repeat(3, auto)  repeat(3, auto)'
          : requestStatusType === 'MemberRequestStatus'
          ? 'repeat(5, auto) 1fr repeat(3, auto)'
          : ' repeat(5, auto) 1fr 2fr 2fr auto',
      gap: '1px',

      backgroundColor: variables.grayLighter,
      border: variables.cardBorder,
      borderRadius: variables.cardBorderRadius,

      '&>*': {
        backgroundColor: '#fff',
        padding: '1rem',
      },

      '&>*+*': {
        marginTop: '0rem',
      },
    },
  },
  address: {
    fontSize: '1rem',
  },
  properyValue: {
    overflow: 'auto',
  },
  approve: {
    color: variables.aLink,
    '&:focus,&:hover,&:active': {
      outline: '1px solid currentColor',
      outlineOffset: '1px',
      fontSize: '1em',
    },
  },
}));
